var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserTeal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "D6494245-BCF3-4D12-8285-7307667B996C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web-app",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "web-my-pub",
    transform: "translate(-122, -432)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user-teal",
    transform: "translate(122, 432)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5,15.8563627 C14.7675,15.8563627 13.2843,15.2395027 12.050634,14.0057827 C10.816878,12.7720447 10.2,11.2889347 10.2,9.55647067 C10.2,7.82397067 10.816878,6.34086067 12.050634,5.10714067 C13.2843,3.87338467 14.7675,3.25650667 16.5,3.25650667 C18.2325,3.25650667 19.71552,3.87338467 20.94924,5.10714067 C22.18296,6.34086067 22.8,7.82397067 22.8,9.55647067 C22.8,11.2889347 22.18296,12.7720447 20.94924,14.0057827 C19.71552,15.2395027 18.2325,15.8563627 16.5,15.8563627 Z M27.26544,29.5640827 L5.73456,29.5640827 C4.975356,29.5640827 4.329786,29.2980427 3.797886,28.7661427 C3.265968,28.2342427 3,27.5887627 3,26.8295227 L3,25.5625027 C3,24.6810427 3.239436,23.8647427 3.71829,23.1136027 C4.197126,22.3624627 4.836918,21.7850227 5.637666,21.3811027 C7.416912,20.5088227 9.211728,19.8545227 11.022096,19.4183827 C12.832482,18.9822427 14.65842,18.7642627 16.5,18.7642627 C18.3414,18.7642627 20.1675,18.9822427 21.97776,19.4183827 C23.7882,19.8545227 25.58298,20.5088227 27.36228,21.3811027 C28.16292,21.7850227 28.80282,22.3624627 29.28162,23.1136027 C29.76042,23.8647427 30,24.6810427 30,25.5625027 L30,26.8295227 C30,27.5887627 29.73396,28.2342427 29.20206,28.7661427 C28.67016,29.2980427 28.0245,29.5640827 27.26544,29.5640827 Z M5.699946,26.8640827 L27.3,26.8640827 L27.3,25.5625027 C27.3,25.1980027 27.19434,24.8605027 26.9832,24.5500027 C26.77206,24.2396827 26.48532,23.9864227 26.12298,23.7902227 C24.57228,23.0264827 22.99098,22.4477827 21.37926,22.0543027 C19.76736,21.6608227 18.14106,21.4640827 16.5,21.4640827 C14.85894,21.4640827 13.23246,21.6608227 11.620686,22.0543027 C10.008912,22.4477827 8.427648,23.0264827 6.876876,23.7902227 C6.514572,23.9864227 6.22785,24.2396827 6.01671,24.5500027 C5.805534,24.8605027 5.699946,25.1980027 5.699946,25.5625027 L5.699946,26.8640827 Z M16.5,13.1565427 C17.49,13.1565427 18.33744,12.8039767 19.0425,12.0989707 C19.74738,11.3939647 20.1,10.5464707 20.1,9.55647067 C20.1,8.56647067 19.74738,7.71897667 19.0425,7.01397067 C18.33744,6.30896467 17.49,5.95647067 16.5,5.95647067 C15.51,5.95647067 14.66238,6.30896467 13.9575,7.01397067 C13.25244,7.71897667 12.899946,8.56647067 12.899946,9.55647067 C12.899946,10.5464707 13.25244,11.3939647 13.9575,12.0989707 C14.66238,12.8039767 15.51,13.1565427 16.5,13.1565427 Z",
    id: "Shape",
    fill: "#00414B",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserTeal);
export default __webpack_public_path__ + "static/media/user-teal.d8f8f0d15b53652f27f20b7a0cbdd9a5.svg";
export { ForwardRef as ReactComponent };